<template>
	<Table
		class="deal-events-table"
		:recordset="dealEventItems"
		:columns="tableColumns"
		:responsive="false"
	/>
</template>

<script>
import Table from '@/components/shells/table/table.vue';
import { mapGetters, mapActions } from 'vuex';
import viewMixin from '@/mixins/view-mixin';

export default {
	name: 'DealEventsTable',
	mixins: [viewMixin],
	components: {
		Table
	},
	data() {
		return {
			tableColumns: [
				{
					columnName: 'id',
					columnDisplayName: 'Id',
					display: false,
					isSortable: false
				},
				{
					columnName: 'employeeName',
					columnDisplayName: 'Employee Name',
					display: true,
					isSortable: false,
					columnModifierName: 'deal-events-employee'
				},
				{
					columnName: 'actionName',
					columnDisplayName: 'Action',
					display: true,
					isSortable: false,
					columnModifierName: 'deal-events-action'
				},
				{
					columnName: 'actionDate',
					columnDisplayName: 'Data/Time',
					display: true,
					isSortable: false,
					columnModifierName: 'deal-events-date'
				}
			]
		};
	},
	props: {
		dealId: {
			type: Number,
			required: true
		}
	},
	async created() {
		if (!this.dealEvents) {
			await this.loadEvents();
		}
	},
	computed: {
		...mapGetters('deal', ['dealEvents']),
		dealEventItems() {
			let items = [];

			if (this.dealEvents && this.dealEvents.items) {
				items = this.dealEvents.items;
			}

			return items;
		}
	},
	methods: {
		...mapActions('deal', ['getDealEventsAction']),
		async loadEvents() {
			await this.getDealEventsAction({
				companyId: this.companyId,
				id: this.dealId
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.deal-events-table::v-deep {
	.table__td.table__td--deal-events-employee {
		width: 220px;
	}
	.table__td.table__td--deal-events-action {
		width: auto;
	}
	.table__td.table__td--deal-events-date {
		width: 180px;
	}
}
</style>
